import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./activityCard.css";
import MiniCalendar from "../../pro/MiniCalendar";

/* ===== Base API robuste (prod & dev) =====
   - Essaie VITE_API_URL / REACT_APP_API_URL
   - Nettoie les slashs finaux + /api éventuel
   - Sinon, retombe sur le même domaine que le front
*/
const RAW =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
  process.env.VITE_API_URL ||
  process.env.REACT_APP_API_URL ||
  "";

const API_BASE = (RAW
  ? RAW.replace(/\/+$/, "").replace(/\/api$/i, "")
  : (typeof window !== "undefined" && window.location.origin) || ""
);

function ActivityCard({ proId: propProId, profilId, annonceId, isApp = false }) {
  const [place, setPlace] = useState(null);
  const navigate = useNavigate();

  // --- Fetch annonce ---
  useEffect(() => {
    async function fetchData() {
      try {
        const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
        const common = {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          credentials: "include",
        };

        if (annonceId) {
          const res = await fetch(`${API_BASE}/api/annonces/${annonceId}`, common);
          const annonce = await res.json();
          setPlace(annonce || null);
        } else if (propProId) {
          // ⚠️ aligne l’endpoint sur le reste du projet
          const res = await fetch(`${API_BASE}/api/annonces/by-user/${propProId}`, common);
          const annonces = await res.json();
          setPlace(Array.isArray(annonces) ? (annonces[0] || null) : annonces || null);
        } else {
          setPlace(null);
        }
      } catch {
        setPlace(null);
      }
    }
    fetchData();
  }, [annonceId, propProId]);

  // --- ID d'annonce à utiliser pour ProfilePro (ProfilePro attend ?proId=ANNONCE_ID) ---
  const annonceIdEffectif = annonceId || place?._id || null;

  // --- Redirection vers le profil pro ---
  function handleGoToProfile() {
    if (!annonceIdEffectif) return; // sécurité
    let url = `/pro/public-profile?proId=${annonceIdEffectif}`;
    if (profilId) url += `&profilId=${profilId}`;
    navigate(url);
  }

  // --- Action principale : si pas connecté → login ; sinon → profil pro ---
  function handlePrimaryAction() {
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    if (!token) {
      navigate("/auth/login");
      return;
    }
    handleGoToProfile();
  }

  // Affichage infos société/profil (gauche)
  function renderHeader() {
    if (!place) return null;

    const imageSrc = place?.image
      ? `${API_BASE}/uploads/${place.image}`
      : "/avatar-pro.png";

    let profil = null;
    if (profilId && Array.isArray(place.profils) && place.profils.length > 0) {
      profil = place.profils.find((p) => String(p._id) === String(profilId));
    }

    const displayName = place?.nameCompany;
    const displayProfession = profil
      ? profil.profession
      : place?.professions && place.professions[0]?.profession;
    const displayAddress = [place?.adresCompany, place?.postalCode, place?.city]
      .filter(Boolean)
      .join(" ");

    const headerClass = `activity-card-header${isApp ? " activity-card-header--app" : ""}`;

    return (
      <div className={headerClass}>
        <div className="activity-card-header__logo">
          <img src={imageSrc} alt="logo" />
        </div>
        <div className="activity-card-header__texts">
          <div className="activity-card-title">{displayName}</div>
          {displayProfession && (
            <div className="activity-card-profession">{displayProfession}</div>
          )}
          {displayAddress && (
            <div className="activity-card-company">{displayAddress}</div>
          )}
        </div>
      </div>
    );
  }

  // Classes selon contexte (Web/App)
  const containerClass = `activity-card${isApp ? " activity-card--app" : ""}`;
  const gridClass = `activity-card__grid${isApp ? " activity-card__grid--app" : ""}`;
  const infoClass = `activity-card-info${isApp ? " activity-card-info--app" : ""}`;
  const btnClass = `prendre-rdv-btn${isApp ? " prendre-rdv-btn--app" : ""}`;
  const calClass = `calendar-section${isApp ? " calendar-section--app" : ""}`;

  return (
    <div className={containerClass}>
      {/* minWidth:0 pour éviter que la grid “compresse” le MiniCalendar */}
      <div className={gridClass} style={{ minWidth: 0 }}>
        {/* Bloc infos à gauche */}
        <div className={infoClass}>
          {renderHeader()}
          <button className={btnClass} onClick={handlePrimaryAction}>
            Prendre rendez-vous
          </button>
        </div>

        {/* Bloc calendrier à droite : MiniCalendar */}
        <div className={calClass} style={{ minWidth: 0, overflow: "visible" }}>
          {place && (
            <MiniCalendar
              annonceId={annonceIdEffectif}
              profilId={profilId}
              onSlotClick={handlePrimaryAction}  // 🔐 si non connecté → /login ; sinon → /profilepro
              isApp={isApp}                       // styles “app” si besoin
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ActivityCard;
